import styled from 'styled-components';

export const DetailSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ContainerAlerts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;

export const PaymentDetails = styled.div`
  background: #fff;
  border-radius: 8px;
  font-family: 'Lato', sans-serif;
  position: relative;
  // margin-bottom: 20px; // Original
  color: #161d1f;
  gap: 24px;
`;

export const FixedWithContainer = styled.div`
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
`;

export const Title = styled.h3`
  font-family: Lato;
  font-size: 24px;
  font-weight: 900;
  line-height: 32px;
  text-align: left;
  color: #161d1f;

  margin-top: 16px;
  margin-bottom: 24px;
`;

export const PaymentTitle = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .title {
    font-family: Lato;
    font-size: 16px;
    font-weight: 900;
    line-height: 24px;
    text-align: left;
    color: #161d1f;

    display: flex;
    justify-content: space-between;
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .item {
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: #161d1f;

    display: flex;
    justify-content: space-between;
  }
`;
export const PaymentDetail = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .divider-primary {
    border: 1px solid #7a959f;
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .divider-secondary {
    border: 1px solid #84b1cc;
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .title {
    font-family: Lato;
    font-size: 16px;
    font-weight: 900;
    line-height: 24px;
    text-align: left;
    color: #161d1f;

    display: flex;
    justify-content: space-between;
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .item {
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: #161d1f;

    display: flex;
    justify-content: space-between;
    .title {
      //styleName: Body/Body 02 - Bold;
      font-family: Lato;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      text-align: left;
      color: #161d1f;
    }
    .subtitle {
      //styleName: Select/Select 02;
      font-family: Lato;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      text-align: left;
      color: #4f6168;
      color: #4f6168;
      width: 202px;
      @media (min-width: 640px) {
        width: 100%;
      }
    }
  }
  .recharge-item {
    display: flex;
    gap: 16px;
    justify-content: space-between;
  }
  .recharge-title {
    //styleName: Body/Body 02 - Bold;
    font-family: Lato;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    text-align: left;
    display: flex;
    gap: 4px;
  }
  .recharge-subtitle {
    //styleName: Select/Select 02;
    font-family: Lato;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: #4f6168;
    width: 202px;
    @media (min-width: 640px) {
      width: 100%;
    }
  }
  .recharge-value {
    //styleName: Body/Body 02 - Regular;
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: right;
    color: #e8212b;
    text-wrap: nowrap;
  }
  .discount-item {
    display: flex;
    gap: 16px;
    justify-content: space-between;
  }
  .discount-title {
    //styleName: Body/Body 02 - Bold;
    font-family: Lato;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    text-align: left;
    display: flex;
    gap: 4px;
  }
  .discount-subtitle {
    //styleName: Select/Select 02;
    font-family: Lato;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: #4f6168;
    width: 202px;
    @media (min-width: 640px) {
      width: 100%;
    }
  }
  .discount-percentage {
    //styleName: Body/Body 02 - Regular;
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: right;
    color: #007f38;
    text-wrap: nowrap;
  }
  .subtotal-title {
    //styleName: Body/Body 02 - Bold;
    font-family: Lato;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    text-align: left;
  }
`;

export const PaymentTotal = styled.div`
  padding: 16px;
  display: flex;

  font-family: Lato;
  font-size: 16px;
  font-weight: 900;
  line-height: 24px;
  text-align: left;

  display: flex;
  justify-content: space-between;
`;

export const PaymentButton = styled.button`
  margin-top: 16px;
  background: var(--background-background-UTP);
  color: var(--nb-primary);
  border: 1px solid var(--nb-primary);
  padding: 10px 24px;
  border-radius: 4px;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    background: var(--button-icon-hover);
  }

  &:active {
    background: var(--card-active);
  }
`;

export const BlockAlert = styled.div`
  color: #161D1F;
  display flex;
  background: var(--background-background-disabled);
  padding: 16px;
  // margin: 24px 0 16px 0;  // Original
  border-radius: 4px;
  gap: 8px;
  align-items: center;
  img {
    margin: 4px;
    width: 20px;
    height: 20px;
    max-width: none;
  }
    a{
    text-decoration: underline;
    color:#5B36F2
    }
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 24px;
  background: var(--button-secondary-main);
  border-radius: 4px;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.3s ease;

  img {
    margin-right: 4px;
  }

  &:hover {
    background-color: var(--primary-hover);
  }

  &:focus {
    background-color: var(--primary-focus);
  }

  &:active {
    background-color: var(--primary-active);
  }

  @media (min-width: 640px) {
    width: auto;
  }
`;

export const ContainerButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 16px;

  @media (min-width: 640px) {
    flex-direction: row;
  }
`;
